import { render, staticRenderFns } from "./detail-ruichen.vue?vue&type=template&id=0c52224c&scoped=true&"
import script from "./detail-ruichen.vue?vue&type=script&lang=js&"
export * from "./detail-ruichen.vue?vue&type=script&lang=js&"
import style0 from "./detail-ruichen.vue?vue&type=style&index=0&id=0c52224c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52224c",
  null
  
)

export default component.exports